<template>
  <modal name="edit" :adaptive="true" width="100%" height="100%" :clickToClose="false" @before-open="beforeOpen" @before-close="beforeClose">
    <h2 class="ttl"><img src="/img/ico_community.png" alt="コミュニティ" width="40" class="mb30"><br>{{$t('editRoom')}}</h2>
    <div class="room-name">
      <p v-if="!$v.name.required || !$v.name.maxLength">
        {{$t(this.getMessage($v.name , {"name" : "ルーム名"}))}}
      </p>
      <p><input type="text" name="comment" placeholder="ルーム名" v-model.trim="$v.name.$model"></p>
    </div>
    <div class="center">
      <button class="mb20" @click="update" >{{$t('updateRoom')}}</button>
      <button class="mb20 delete" @click="remove">{{$t('deleteRoom')}}</button>
      <button class="cancel" @click="cancel">{{$t('cancel')}}</button>
    </div>
  </modal>
</template>

<script>
import firebase from 'firebase'
import { required , maxLength } from "vuelidate/lib/validators"

export default {
  data () {
    return {
      db : firebase.firestore(),
      name: "",
      id : "",
    }
  },
  validations: {
    name: {
      required,
      maxLength : maxLength(50)
    },
  },
  methods: {
    beforeOpen (event) {
      this.id = event.params.id
      this.name = event.params.name
    },
    beforeClose () {
      this.name = ""
    },
    async update () {
      if (this.$v.$invalid) {
        return
      }
      try {
        await this.db.collection("rooms").doc(this.id).update({
          name: this.name,
          updated_at: firebase.firestore.FieldValue.serverTimestamp(),
        })
        this.$toasted.success(this.$t('updatedRoom'))
        this.$modal.hide('edit')
        this.$emit('reload-event')
      } catch {
        this.$toasted.error(this.$t('failUpdateRoom'))
      }
    },
    async remove () {
      if(!confirm(this.$t('promptDeleteRoom'))) {
        return
      }
      try {
        await this.db.collection("rooms").doc(this.id).delete()
        this.$toasted.success(this.$t('deletedRoom'))
        this.$modal.hide('edit')
        this.$emit('reload-event')
      } catch {
        this.$toasted.error(this.$t('failDeleteRoom'))
      }
    },
    cancel () {
      this.$modal.hide("edit")
    }
  }, 
}
</script>
